"use client";

import React from "react";

export function Cta13() {
  return (
    /* bg-wood-light = tvoje světle šedá */
    <section className="bg-wood-light text-black font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto grid grid-cols-1 items-center gap-y-10 md:grid-cols-2 md:gap-x-12 lg:gap-x-20">
        
        {/* Levá strana: Nadpis - Gelasio */}
        <div className="text-center md:text-left">
          <h2 className="text-[36px] font-bold font-serif leading-[1.1] sm:text-[40px] md:text-[48px] lg:text-[56px]">
            Připraveni začít váš projekt?
          </h2>
        </div>

        {/* Pravá strana: Text a Tlačítka */}
        <div className="flex flex-col items-center md:items-start">
          <p className="text-base sm:text-lg md:text-xl opacity-80 mb-8 text-center md:text-left">
            Zavolejte nám nebo napište. Prvního setkání se nebojíme.
          </p>
          
          <div className="flex flex-wrap gap-4 justify-center md:justify-start">
            {/* Tlačítko Zavolat - Černá kulatá pilulka, odkaz na telefon */}
            <a 
              href="tel:+420723856780"
              className="px-8 py-3 bg-black text-white font-bold rounded-full hover:bg-opacity-80 transition-all text-center min-w-[140px]"
            >
              VOLAT
            </a>
            
            {/* Tlačítko Kontakt - Černá kulatá pilulka, odkaz na e-mail */}
            <a 
              href="mailto:jiri@tesarstvi-sindelar.cz"
              className="px-8 py-3 bg-black text-white font-bold rounded-full hover:bg-opacity-80 transition-all text-center min-w-[140px]"
            >
             jiri@tesarstvi-sindelar.cz
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}